<template>
  <div class="d-flex ga-3 flex-wrap">
    <generate-printed-form-item
      label="Аналіз звітності"
      description="Звіт забезпечує фіксацію усіх змін, включаючи появу нових боржників, зникнення або коригування існуючих записів"
      @generate="analyzeReport">
      <template #detailed-description>
        <div>
          <p class="mb-1" style="text-indent: 8px">
            Забезпечення <b>прозорості</b> та <b>контрольованості змін</b>, які
            відбуваються у масиві даних про боржників між двома суміжними
            періодами подання.
          </p>
          <p class="mb-1" style="text-indent: 8px">
            Звіт забезпечує <b>фіксацію змін</b>, включаючи появу нових
            боржників, зникнення або коригування існуючих записів.
          </p>
          <p class="mb-1" style="text-indent: 8px">
            Такий підхід відповідає вимогам
            <b>внутрішнього контролю</b> та нормативним актам щодо повноти та
            достовірності поданих даних.
          </p>
        </div>
      </template>
    </generate-printed-form-item>
    <generate-printed-form-item
      label="Фінансовий аналіз звітів"
      @generate="financialAnalyzeReport">
    </generate-printed-form-item>
    <generate-printed-form-item
      label="Деталізація пакетів"
      @generate="detailReport">
    </generate-printed-form-item>
    <generate-printed-form-item
      label="Дублікати боржників"
      description="Звіт відображає дублікати боржників за обраний період із зазначенням кількості повторів та деталей пакетів (код, автор, дати, статус, ідентифікаційні дані)."
      @generate="debtorDuplicatesReport">
    </generate-printed-form-item>
    <generate-printed-form-item
      label="Хронологія боржника"
      description="Повна історія подань даних боржника до Кредитного реєстру за ідентифікатором — коли подавалися дані, що було припинено та що залишається діючим."
      @generate="debtorChronologyReport">
    </generate-printed-form-item>
  </div>
</template>

<script lang="ts">
import { openDialog } from '@/plugins/dialog'
import { useRouter } from 'vue-router'
import {
  financialAnalyzeReport as financialAnalyzeReportRequest,
  detailReport as detailReportRequest,
} from '@/request/report'
import GeneratePrintedFormItem from './GeneratePrintedFormItem.vue'

export default {
  name: 'GeneratePrintedForm',
  components: { GeneratePrintedFormItem },
  setup() {
    const router = useRouter()
    const analyzeReport = () => {
      return openDialog({
        name: 'ReportAnalyze',
        params: {
          cb() {
            router.push({ name: 'report-printed-form-result' })
          },
        },
      })
    }

    const financialAnalyzeReport = () => {
      openDialog({
        name: 'ReportSelect',
        params: {
          title: 'Оберіть період аналізу звітності',
          cb: ({ reportId }) => {
            financialAnalyzeReportRequest(reportId)
          },
        },
      })
    }

    const detailReport = () => {
      openDialog({
        name: 'ReportSelect',
        params: {
          title: 'Оберіть період деталізації пакетів',
          cb: ({ reportId }) => {
            detailReportRequest(reportId)
          },
        },
      })
    }

    const debtorDuplicatesReport = () => {
      return openDialog({
        name: 'DebtorDuplicates',
        params: {
          cb() {
            router.push({ name: 'report-printed-form-result' })
          },
        },
      })
    }

    const debtorChronologyReport = () => {
      return openDialog({
        name: 'DebtorChronology',
        params: {
          submitLabel: 'Сформувати',
          cb() {
            router.push({ name: 'report-printed-form-result' })
          },
        },
      })
    }

    return {
      analyzeReport,
      financialAnalyzeReport,
      detailReport,
      debtorDuplicatesReport,
      debtorChronologyReport,
    }
  },
}
</script>

<style scoped lang="scss"></style>
